import { render, staticRenderFns } from "./LoadData.vue?vue&type=template&id=ae6cb664&scoped=true"
import script from "./LoadData.vue?vue&type=script&lang=js"
export * from "./LoadData.vue?vue&type=script&lang=js"
import style0 from "./LoadData.vue?vue&type=style&index=0&id=ae6cb664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6cb664",
  null
  
)

export default component.exports